import {messages} from '@smartmixin/i18n';
import {Box, Link, List, ListItem, Typography} from '@mui/material';
import {useIntl} from 'react-intl';
import RouterLink from '../../lib/RouterLink';
import {useHelpBasePath} from '../hooks/useHelpLocale';
import {Article} from '../types';

type RelatedArticlesProps = {
  articles: Article[];
};

const RelatedArticles = ({articles}: RelatedArticlesProps) => {
  const {formatMessage} = useIntl();
  const helpBasePath = useHelpBasePath();

  if (articles.length === 0) {
    return null;
  }

  return (
    <Box sx={{mt: 4, pt: 2, borderTop: 1, borderColor: 'divider'}}>
      <Typography variant="h6" gutterBottom>
        {formatMessage(messages.helpCenter.relatedArticles)}
      </Typography>
      <List dense disablePadding>
        {articles.map((article) => (
          <ListItem key={article.id} disablePadding sx={{py: 0.5}}>
            <Link component={RouterLink} to={`${helpBasePath}/${article.slug}`}>
              {article.title}
            </Link>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default RelatedArticles;
